module.exports = __webpack_public_path__ + "static/media/Pin_battery-icon.04ca0a04.svg";